if (!customElements.get("product-inventory")) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    async initLazySection() {
      this.inventoryNotice = this.querySelector(".js-inventory-notice");
      this.urgencyMessage = this.querySelector(".js-inventory-urgency");
      this.indicatorBar = this.querySelector(".js-inventory-indicator");
      this.addToCartMain = document.querySelector(".product-info__add-to-cart .add-to-cart-main");
      this.addToCartSample = document.querySelector(
        ".product-info__add-to-cart .add-to-cart-sample"
      );
      this.stockCheckForm = document.getElementById("stock-check-form");
      this.quantityInput = document.querySelector("input.qty-input__input.input");

      /**
       * *** Inventoy Type ***
       * 1: Strict Level - No backorder.  Show stock check form on low stock
       * 2: Backorder - Show backorder note. Don't show stock check form
       * 3: Always available
       */
      const inventory = await this.getProductInventory();
      const urlParams = new URLSearchParams(window.location.search);

      this.inventoryCount = inventory.quantity;
      this.inventoryType = inventory.type;
      this.inventoryNote =
        inventory.note && this.inventoryType < 3 ? `Lead time: ${inventory.note}` : "";
      this.forceBackorder = urlParams.get("backorder") === "true";

      this.updateInventory();

      /**
       * Manual Stock Form on quantity exceed
       */
      this.quantityInput.addEventListener("change", this.triggerStockCheckForm.bind(this));
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    async getProductInventory() {
      const response = await fetch(
        `https://decoratorsbestam.com/api/inventories/?sku=${encodeURIComponent(this.dataset.sku)}`,
        {
          headers: { Authorization: "Token 69da527e69980a6f107a283e7e01dfff7a225019" },
        }
      );
      const inventory = (await response.json())?.results?.[0];

      return (
        inventory ?? {
          quantity: 0,
          type: 1,
          note: "",
        }
      );
    }

    /**
     * Updates the inventory notice
     */
    updateInventory() {
      const inventoryLevel =
        this.inventoryCount > 0 ? "normal" : this.inventoryNote ? "low" : "very_low";
      this.setAttribute("data-inventory-level", inventoryLevel);

      this.hidden = false;

      if (this.inventoryType === 1) {
        this.inventoryNotice.innerHTML = theme.strings.onlyXLeft.replace(
          "[quantity]",
          `<strong>${this.inventoryCount}</strong>`
        );
      } else {
        this.inventoryNotice.innerText = "In Stock";
      }

      if (this.inventoryNote) {
        this.urgencyMessage.innerText = this.inventoryNote;
      }

      this.triggerStockCheckForm();
    }

    triggerStockCheckForm() {
      const showStockCheckForm =
        this.inventoryCount < parseInt(this.quantityInput.value) &&
        this.inventoryType === 1 &&
        !this.forceBackorder;

      if (showStockCheckForm) {
        this.stockCheckForm.classList.remove("hidden");
        this.addToCartMain.disabled = true;
        this.addToCartSample.disabled = true;
      } else {
        this.stockCheckForm.classList.add("hidden");
        this.addToCartMain.disabled = false;

        if (this.addToCartSample.dataset.status === "true") {
          this.addToCartSample.disabled = false;
        }
      }
    }
  }

  customElements.define("product-inventory", ProductInventory);
}
